//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import { getTaskStatus } from "@/components/tasks/myTeamsTasks/constants";

export default {
    name: "TasksStatus",
    components: {},
    props: {
        dashboardType: {
            type: String,
            default: "user"
        }
    },
    data() {
        return {
            loading: true,
            taskStatusArray: []
        };
    },
    computed: {
        ...mapGetters("dashboard", ["tasksStatus", "taskForTeam"]),
        ...mapGetters("tasks", ["getSelectedTasksFilter"])
    },
    watch: {
        // eslint-disable-next-line func-names
        "$backendDrivenEvents.state.refreshTasks": function (v) {
            if (v && this.dashboardType === "user") {
                this.getTasksStatus();

                setTimeout(() => {
                    this.$backendDrivenEvents.state.refreshTasks = false;
                }, 1000);
            }
        },
        tasksStatus: {
            handler(newValue) {
                if (newValue) {
                    this.taskStatusArray = [];
                    this.taskStatusArray.push({
                        name: this.$t("dashboard.totalTasks"),
                        functionParam: "ALL",
                        value: newValue.total,
                        colorClass: ""
                    });
                    this.taskStatusArray.push({
                        name: this.$t("dashboard.charts.onTrack"),
                        functionParam: "ON_TRACK",
                        value: newValue.onTrack,
                        colorClass: "text-secondary",
                        color: "positive"
                    });
                    this.taskStatusArray.push({
                        name: this.$t("dashboard.charts.attentionState"),
                        functionParam: "ATTENTION",
                        value: newValue.attention
                    });
                    this.taskStatusArray.push({
                        name: this.$t("tasks.filterBy.inWarning"),
                        functionParam: "AT_RISK",
                        value: newValue.atRisk,
                        colorClass: "text-warning",
                        color: "warning"
                    });
                    this.taskStatusArray.push({
                        name: this.$t("dashboard.exceededDeadline"),
                        functionParam: "OVERDUE",
                        value: newValue.overdue,
                        colorClass: "text-negative",
                        color: "negative"
                    });
                }
            }
        },
        dashboardType: {
            handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.getCardsInfo();
                }
            }
        },
        getSelectedTasksFilter: {
            handler(newValue, oldValue) {
                if (newValue && oldValue && oldValue.groupId && newValue.groupId !== oldValue.groupId) {
                    this.getCardsInfo();
                }
            }
        }
    },
    created() {
        this.getCardsInfo();
    },
    methods: {
        getTaskStatus,
        ...mapActions("dashboard", ["getTasksStatus", "getTaskForTeam"]),
        toTask(prop) {
            const query = { tab: "todo", ...this.$route.query, ...(prop === "ALL" ? {} : { statuses: prop }) };

            if (this.dashboardType === "user") {
                this.$store.commit("main/setFromMyTeamsTasksMenu", false);
                this.$router.push({
                    path: "tasks/myTasks",
                    query
                });
            } else if (this.dashboardType === "team") {
                this.$store.commit("main/setFromMyTeamsTasksMenu", true);
                this.$router.push({
                    path: "tasks/teamTasks",
                    query
                });
            }
        },
        getCardsInfo() {
            if (this.dashboardType === "user") {
                this.getTasksStatus().then(() => {
                    this.loading = false;
                });
            } else if (
                this.dashboardType === "team"
                && this.getSelectedTasksFilter && this.getSelectedTasksFilter.groupId
            ) {
                this.getTaskForTeam(this.getSelectedTasksFilter.groupId).then(() => {
                    this.loading = false;
                });
            }
        }
    }
};
